import './rst.less';

$('.direct-delivery-label').on('click', function () {
    var el = $(this);
    $.post(
        '/cart/setDirectWarehouse/',
        {
            code: $(el).attr('data-code'),
        },
        function () {
            document.location.reload();
        }
    );
});

$(document).ready(function () {
    $('.fast-message').tipTip();
});
